import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getTimelinesService = async (projectId) => {
  const apiPath = `timelines/project/${projectId}/get-timelines`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    isLocalApiRequest: false,
  });
  const response = await axios(signedRequest);

  return response.data;
};
